import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCreateBabyRegistry = loadable(() => import(/* webpackChunkName: "content/createbabyregistry" */ '.'));
